import React, { useState, useEffect, useRef } from "react";
import Tab1Image from "../img/envision/healthcare/new/helathcareinsturments.jpg";
import Tab2Image from "../img/envision/healthcare/new/healthecaremangment.jpg";
import Tab3Image from "../img/envision/healthcare/new/healthcaresecurity.jpg";
import Tab4Image from "../img/envision/healthcare/new/pharmacetical.jpg";
import Tab5Image from "../img/envision/healthcare/cards/healthig5.jpg";
import Tab6Image from "../img/envision/healthcare/new/psistandards.jpg";
import Tab8Image from "../img/envision/healthcare/healthcarethreetab/healthcareone.jpg";
import Tab9Image from "../img/envision/healthcare/healthcarethreetab/healthcaretwo.jpg";
import Tab10Image from "../img/envision/healthcare/healthcarethreetab/healthcarethree.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const Healthcarethirdtab = () => {
    const [activeTab, setActiveTab] = useState("tab1");
    const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay
    const tabContainerRef = useRef(null);
    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    const handleKnowMoreClick = () => {
        // Navigate to the documentaerospacepage with the specific hash
        navigate("/documentHealthcarePage#documentHealthcarePageSEeconddata");
    };
    const [isHovered, setIsHovered] = useState(false);
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
    };
    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
        let tabInterval;

        if (!isHovered && isAutoPlayActive) {
            tabInterval = setInterval(() => {
                setActiveTab((prevTab) => {
                    const nextTabNum = parseInt(prevTab.replace("tab", "")) % 11 + 1;
                    return `tab${nextTabNum}`;
                });
            }, 3000);
        }

        return () => clearInterval(tabInterval);
    }, [activeTab, isHovered, isAutoPlayActive]);

    useEffect(() => {
        if (tabContainerRef.current) {
            const container = tabContainerRef.current;
            const activeTabElement = document.getElementById(activeTab);

            if (activeTabElement) {
                // Get the position of the active tab within the container
                const activeTabOffsetTop = activeTabElement.offsetTop;

                // Smoothly scroll the container to that position
                container.scrollTo({
                    top: activeTabOffsetTop - container.offsetTop, // Adjust based on the container's offset
                    behavior: 'smooth', // Smooth scroll
                });
            }
        }
    }, [activeTab]);

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            // display: "flex",
            width: "80%",
            margin: "50px auto",
        },
        tabNav: {
            // display: "flex",
            flexDirection: "column",
            borderRight: "1px solid #fff",
            height: "425px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
            direction: "rtl", // This makes the scrollbar appear on the left side
        },

        tabButton: {
            padding: "15px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            // display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            // marginLeft: "10px",
            cursor: "pointer",
            height: "450px",
            overflowY: "auto"
        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
            // marginTop:'350px',
            height:"705px"
        },
        icon: {
            marginRight: "10px",
            fontSize: "24px",
            color: "#009ca5",
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
        },
        knowMoreButtonHover: {
            backgroundColor: "#e68a00",
        },
    };

    return (
        <div style={{ marginTop: '100px' }}>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: "rgb(236 115 34)" }}> Gen AI enabled IT & OT Transformation  </span>Services Offerings
            </h1>
            <div style={styles.container} className="tabclass-container-data">
                {/* <div style={styles.tabNav} className="tabdata">
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Secured & Modern Infrastructure
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Robust Disaster Recovery & Business Continuity
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab3")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Transformed Applications (ERP & IT Modernization)
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab4")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Cloud Adoption & AI-Driven Security
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab5" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab5")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Business-Aligned IT & Security
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab6" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab6")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Smart & Secure Medical Equipment Management
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab7" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab7")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        AI-Driven Supply Chain & Inventory Optimization
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab8" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab8")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Automated Workflow & Process Optimization
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab9" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab9")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Intelligent Energy & Facility Management for Hospitals
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab10" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab10")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Connected & Interoperable Medical Devices
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab11" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab11")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                          }}
                    >
                        Predictive Maintenance & AI-Based Biomedical Equipment Servicing
                    </button>

                </div> */}



                <div
                    style={{
                        ...styles.tabNav,
                        overflowY: 'auto', // Allow scrolling within the container
                        scrollBehavior: 'smooth', // Enable smooth scrolling within the container
                    }}
                    ref={tabContainerRef}
                    className="tabdata"
                >
                    {[
                        'Secured & Modern Infrastructure',
                        'Robust Disaster Recovery & Business Continuity',
                        'Transformed Applications (ERP & IT Modernization)',
                        'Cloud Adoption & AI-Driven Security',
                        'Business-Aligned IT & Security',
                        'Smart & Secure Medical Equipment Management',
                        'AI-Driven Supply Chain & Inventory Optimization',
                        'Automated Workflow & Process Optimization',
                        'Intelligent Energy & Facility Management for Hospitals',
                        'Connected & Interoperable Medical Devices',
                        'Predictive Maintenance & AI-Based Biomedical Equipment Servicing',

                    ].map((tab, index) => {
                        const tabId = `tab${index + 1}`;
                        return (
                            <button
                                key={tabId}
                                id={tabId}
                                style={{
                                    ...styles.tabButton,
                                    ...(activeTab === tabId
                                        ? { ...styles.activeTabButton, backgroundColor: 'rgb(236 115 34)', color: '#fff' }
                                        : {}),
                                }}
                                onClick={() => handleTabClick(tabId)}
                                className="tab-button-width"
                                onMouseEnter={(e) => {
                                    if (activeTab !== tabId) {
                                        e.currentTarget.style.backgroundColor = '#000'; // Change background to black on hover
                                        e.currentTarget.style.color = '#fff'; // Change text to white on hover
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (activeTab !== tabId) {
                                        e.currentTarget.style.backgroundColor = ''; // Revert background on mouse leave
                                        e.currentTarget.style.color = ''; // Revert text color on mouse leave
                                    }
                                }}
                            >
                                {tab}
                            </button>
                        );
                    })}
                </div>

                <div style={styles.card} className="card-data-vertica-tabs"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <img
                        src={{ tab1: Tab8Image, tab2: Tab9Image, tab3: Tab10Image, tab4: Tab4Image, tab5: Tab5Image, tab6: Tab6Image, tab7: Tab4Image, tab8: Tab2Image, tab9: Tab1Image, tab10: Tab3Image, tab11: Tab5Image, }[activeTab]}
                        alt="Healthcare"
                        style={styles.image}
                        className="tab-image-data"
                    />
                    <div style={styles.textContent} className="health-card-thard-data">
                        {(() => {
                            const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                            const contentArray = [
                                [
                                    [" <strong>Problem:</strong> Healthcare organizations still rely on aging, siloed IT systems that lack real-time security monitoring, advanced encryption, and compliance with HIPAA, GDPR, and India’s PDPB. These legacy infrastructures are highly vulnerable to ransomware attacks, patient data breaches, and operational downtimes, putting sensitive medical records and critical healthcare services at risk."],
                                    [" <strong>How DREBCON Can Help:</strong>DREBCON transforms healthcare IT with AI-driven security frameworks, integrating Zero Trust Architecture (ZTA), AI-powered threat intelligence, and blockchain-based patient identity management. Our secure, interoperable IT frameworks enable seamless EHR (Electronic Health Record) integrations, IoT-enabled medical device connectivity, and real-time monitoring of IT assets, ensuring a cyber-resilient healthcare ecosystem."],
                                    [" <strong>Result:</strong> Healthcare organizations gain a secured and modernized IT infrastructure with AI-driven cybersecurity, automated compliance enforcement, and real-time threat mitigation. uninterrupted healthcare operations"],
                                ],
                                [
                                    [" <strong>Problem:</strong> Healthcare institutions operate in a 24/7 mission-critical environment, where system failures, ransomware attacks, and data corruption can disrupt patient care, delay medical procedures, and cause financial losses. Many healthcare providers lack real-time disaster recovery (DR) solutions, automated failover mechanisms, and multi-location data backups, leading to extended downtime in emergencies."],
                                    [" <strong>How DREBCON Can Help:</strong> DREBCON ensures robust disaster recovery (DR) and business continuity (BCP) by implementing geo-distributed data replication, real-time failover automation, and AI-powered risk assessment models.  BCP frameworks align with global healthcare regulations (HIPAA, HITRUST, NIST), ensuring zero data loss, instant system recovery, and uninterrupted medical services. AI-powered incident response and automated backup validation fortify healthcare resilience against cyberattacks, natural disasters, and system failures."],
                                    [" <strong>Result:</strong> Healthcare organizations achieve resilient, AI-driven disaster recovery, with instant failover capabilities, real-time compliance tracking, and uninterrupted patient care services"]

                                ],
                                [
                                    ["	<strong>Problem:</strong> Outdated hospital management systems, legacy ERPs, and disconnected healthcare applications lead to poor interoperability, inefficient workflows, and fragmented patient records. Many healthcare organizations struggle with manual administrative processes, delayed claims processing, and disconnected financial and clinical operations, resulting in higher costs, compliance risks, and reduced operational efficiency."],
                                    [" <strong>How DREBCON Can Help:</strong> DREBCON accelerates application transformation by modernizing ERPs, hospital information systems (HIS), and clinical management applications. We migrate legacy healthcare systems to AI-powered, cloud-native architectures, integrating real-time analytics, robotic process automation (RPA), and AI-driven decision-making tools. Our FHIR and HL7-compliant API integrations ensure seamless interoperability."],
                                    [" <strong>Result:</strong> Healthcare organizations achieve seamless, AI-driven application modernization, improving interoperability, automation, and real-time decision-making, ultimately enhancing patient care, reducing costs, and streamlining healthcare operations."],
                                    // [" Interoperability and data security audits."]

                                ],
                                [
                                    ["	<strong>Problem:</strong> Many healthcare institutions struggle with on-premise data centers that are costly, inflexible, and difficult to scale. The lack of cloud adoption results in data silos, slow system performance, and security vulnerabilities, limiting AI-driven diagnostics, real-time telemedicine, and connected healthcare ecosystems. Additionally, concerns about data privacy, compliance, and regulatory approvals have slowed down cloud migration in healthcare."],
                                    [" <strong>How DREBCON Can Help:</strong> DREBCON facilitates secure and compliant cloud transformation, enabling healthcare organizations to adopt hybrid, multi-cloud, and edge computing solutions. We implement secure cloud-hosted EHRs, AI-powered cloud analytics, and disaster-resilient. Our cloud solutions comply with HIPAA, PDPB, GDPR, and HITRUST standards, enabling secure cloud-based telemedicine, AI-assisted diagnostics."],
                                    [" <strong>Result:</strong> Healthcare providers achieve scalable, AI-driven cloud adoption, with enhanced security, cost optimization, and seamless interoperability across healthcare systems. This enables faster innovation in telemedicine, AI-driven diagnostics, and predictive patient care."],


                                ],
                                [
                                    ["	<strong>Problem:</strong> Healthcare organizations often face IT-security misalignment, where technology investments do not align with business goals, regulatory requirements, or patient care priorities. This leads to gaps in cybersecurity strategy, inefficiencies in IT resource allocation, and reactive security postures. Without cohesive IT and security alignment, healthcare providers struggle with rising cyber threats, and data governance challenges."],
                                    ["<strong>How DREBCON Can Help:</strong> DREBCON bridges this gap by ensuring business-driven IT and security alignment. We develop customized IT security roadmaps that align with clinical operations, financial management, and regulatory mandates. Our AI-powered security automation, risk-based access controls,  compliance tracking, and predictive threat management."],
                                    [" <strong>Result:</strong> Healthcare organizations gain business-aligned IT and security strategies, ensuring optimized cybersecurity investments, AI-powered compliance tracking, and proactive risk management. This enhances regulatory adherence, patient data security, and operational resilience"],


                                ],
                                [
                                    [" <strong>Problem:</strong> Healthcare facilities rely on critical medical machinery such as MRI scanners, ventilators, and robotic surgical systems. However, legacy asset management leads to untracked maintenance schedules, frequent equipment downtime, and security vulnerabilities due to outdated firmware and unpatched software. Inefficient equipment utilization increases operational costs and reduces patient throughput."],
                                    [" <strong>How DREBCON Can Help:</strong> DREBCON deploys AI-powered asset monitoring and predictive maintenance to optimize medical machinery uptime and security. Our IoT-enabled equipment tracking, AI-driven diagnostics, and automated firmware updates proactively prevent failures and improve equipment performance. We integrate blockchain-based digital twins and real-time telemetry analytics.ensuring compliance with IEC 62443 and FDA cybersecurity guidelines."],
                                    ["<strong>Result:</strong> Healthcare providers benefit from increased asset lifespan, optimized equipment usage, and reduced maintenance costs. AI-driven preventive maintenance minimizes downtime, enhances medical device security, and ensures uninterrupted patient care"],

                                ],
                                [
                                    ["<strong>Problem:</strong> Hospitals and healthcare providers struggle with complex supply chains, managing pharmaceuticals, medical devices, and disposable surgical supplies. Manual inventory tracking, fragmented procurement systems, and demand surges result in stockouts of critical medicines, supply chain bottlenecks, and excessive wastage, ultimately increasing costs and impacting patient care delivery."],
                                    ["<strong>How DREBCON Can Help:</strong> DREBCON transforms healthcare supply chains with AI-powered demand forecasting, automated inventory tracking, and blockchain-based supply chain transparency. Our real-time IoT-driven inventory management system prevents stockouts, eliminates wastage, and ensures just-in-time (JIT) replenishment. AI-based predictive analytics optimizes procurement and mitigates supply chain risks during pandemics, emergencies, and geopolitical disruptions."],
                                    ["<strong>Result:</strong> Healthcare providers achieve supply chain efficiency, reduced procurement costs, and real-time inventory visibility. AI-driven insights improve stock accuracy, minimize disruptions, and ensure the availability of critical medical supplies"],

                                ],
                                [
                                    ["<strong>Problem:</strong> Many healthcare institutions still rely on manual, paper-based processes for patient admissions, insurance claims processing, and administrative workflows. These outdated systems cause delays in patient care, increase labor costs, and introduce billing inefficiencies. Additionally, siloed IT systems do not integrate clinical, financial, and operational data, hindering real-time decision-making and coordination."],
                                    ["How DREBCON Can Help: DREBCON leverages AI-driven robotic process automation (RPA) and intelligent workflow orchestration to automate patient onboarding, claims verification, and revenue cycle management. Our AI-powered hospital management systems (HMS) and enterprise resource planning (ERP) solutions seamlessly integrate clinical, operational, and financial data, ensuring real-time decision-making and workflow optimization."],
                                    ["Result: Healthcare institutions benefit from faster administrative turnaround times, reduced operational costs, and increased workflow efficiency. AI-powered automation eliminates redundancies, accelerates processes, and enhances patient experience."],

                                ],
                                [
                                    ["<strong>Problem:</strong>Large hospitals and healthcare facilities consume high amounts of energy due to round-the-clock medical equipment usage, HVAC systems, and high-power-consuming diagnostic machinery. Inefficient energy utilization, lack of real-time monitoring, and reactive facility maintenance lead to unnecessary costs, operational inefficiencies, and increased environmental impact."],
                                    ["<strong>How DREBCON Can Help:</strong> integrates AI-powered energy management systems, smart sensors, and predictive facility maintenance to optimize energy consumption and improve hospital sustainability. Our IoT-driven facility management platforms provide real-time monitoring of energy usage, water consumption, and infrastructure health. AI-powered predictive facility maintenance ensures proactive repairs of critical infrastructure, reducing unexpected breakdowns and downtime."],
                                    ["<strong>Result:</strong> Hospitals achieve lower energy costs, improved sustainability, and enhanced infrastructure resilience. AI-driven energy optimization reduces waste, prevents failures, and improves the operational efficiency of healthcare facilities."],

                                ],
                                [
                                    ["<strong>Problem:</strong> Many healthcare institutions still rely on manual, paper-based processes for patient admissions, insurance claims processing, and administrative workflows. These outdated systems cause delays in patient care, increase labor costs, and introduce billing inefficiencies. Additionally, siloed IT systems do not integrate clinical, financial, and operational data, hindering real-time decision-making and coordination."],
                                    ["<strong>How DREBCON Can Help:</strong> DREBCON enables seamless medical device integration using FHIR, HL7, and IoT-based interoperability frameworks. Our solutions bridge disparate medical technologies, AI-assisted diagnostics, and real-time patient monitoring platforms. By enabling secure data exchange between IoT-connected medical devices, hospital networks, and cloud-based AI analytics, we enhance clinical decision-making and improve healthcare outcomes."],
                                    ["<strong>Result:</strong> Hospitals benefit from fully integrated, AI-driven medical device ecosystems that improve diagnostic accuracy, accelerate treatment, and optimize patient monitoring workflows. AI-powered connectivity ensures scalable, real-time, and data-driven healthcare innovations"],

                                ],
                                [
                                    ["<strong>Problem:</strong> Medical equipment failures pose serious risks to patient safety and hospital efficiency. Traditional reactive maintenance approaches result in unexpected breakdowns, increased repair costs, and disrupted patient care. Without AI-powered predictive maintenance, hospitals struggle to proactively monitor asset performance and prevent failures."],
                                    ["<strong>How DREBCON Can Help:</strong> DREBCON deploys AI-powered predictive maintenance solutions that use machine learning algorithms, real-time telemetry, and anomaly detection to predict equipment failures before they occur. Our automated maintenance scheduling and remote diagnostics capabilities extend the lifecycle of high-value assets, reduce repair costs, and ensure uninterrupted medical services."],
                                    ["<strong>Result:</strong> Healthcare providers experience fewer equipment failures, lower maintenance costs, and increased uptime of critical medical devices. AI-powered predictive maintenance enhances reliability, ensuring consistent and efficient healthcare service delivery."],

                                ],
                                // Add similar for other tabs/content...
                            ];

                            const selectedContent = contentArray[tabIndex] || [];

                            return selectedContent.map((listItems, listIndex) => (
                                <ul key={listIndex}>
                                    {listItems.map((point, itemIndex) => (
                                        <li key={itemIndex} dangerouslySetInnerHTML={{ __html: point }} />
                                    ))}
                                </ul>
                            ));
                        })()}


                        <button
                            style={styles.knowMoreButton}
                            onClick={handleKnowMoreClick}
                            onMouseEnter={(e) => (e.target.style.backgroundColor = "#e68a00")}
                            onMouseLeave={(e) => (e.target.style.backgroundColor = "rgb(236 115 34)")}
                            className="know-more-btn"
                        >
                            Know More
                        </button>
                    </div>
                </div>
            </div>

            {/* Dot Navigation */}
            <div style={styles.dotNav}>
                {[...Array(11)].map((_, index) => {
                    const tab = `tab${index + 1}`;
                    return (
                        <div
                            key={tab}
                            style={{
                                ...styles.dot,
                                ...(activeTab === tab ? styles.activeDot : {}),
                            }}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default Healthcarethirdtab;
